var root = require('./_root');

/** Built-in value references. */
var _Symbol = root.Symbol;

module.exports = _Symbol;


/*****************
 ** WEBPACK FOOTER
 ** ./math-input/~/lodash/_Symbol.js
 ** module id = 558
 ** module chunks = 0 2
 **/